import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FlexBox } from '../box';
import { Skeleton } from '../skeleton';
import { styled } from '../styled';
export const changeValue = (props) => {
    const { step, value, min, max, key, shiftKey } = props;
    const newStep = shiftKey ? 10 : step;
    const defaultValue = value ?? 0;
    const newValue = (() => {
        switch (key) {
            case 'ArrowDown':
                return Number((defaultValue - newStep).toFixed(15));
            case 'ArrowUp':
                return Number((defaultValue + newStep).toFixed(15));
            default:
                return undefined;
        }
    })();
    if (newValue !== undefined) {
        return Math.min(max, Math.max(min, newValue));
    }
    return newValue;
};
const OverlaySkeleton = styled(Skeleton)({
    position: 'absolute'
});
export const fieldErrorProps = (error, helperText) => {
    const normalizedError = typeof error === 'boolean' ? undefined : error;
    return {
        error: Boolean(error),
        helperText: normalizedError ?? helperText
    };
};
export const FieldSkeleton = ({ width, children }) => (_jsxs(FlexBox, { position: "relative", width: width, children: [_jsx(OverlaySkeleton, { width: "100%", height: "100%" }), _jsx(FlexBox, { visibility: "hidden", children: children })] }));
